import { render, staticRenderFns } from "./AdvisorCard.vue?vue&type=template&id=697aede0"
import script from "./AdvisorCard.vue?vue&type=script&lang=js"
export * from "./AdvisorCard.vue?vue&type=script&lang=js"
import style0 from "./AdvisorCard.vue?vue&type=style&index=0&id=697aede0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports